



































































import Vue from 'vue'
export default Vue.extend({
  name: 'Input',
  props: {
    label: String,
    type: String,
    name: String,
    id: String,
    value: String,
    error: String,
    handleBlur: Function
  },
  data() {
    return {
      floatLabel: false,
      smallFont: false,
      rows: 1
    }
  },
  computed: {
    isTextArea() {
      return this.type === 'textarea'
    },
    hasError() {
      return this.error !== ''
    }
  },
  methods: {
    handleInput(value: string) {
      this.$emit('input', value)
      this.checkValue(value)
      if (this.isTextArea) {
        const heightCalc = this.$refs.heightCalc as HTMLElement
        const inputField = this.$refs.inputField as HTMLElement
        heightCalc.style.width = `${inputField.getBoundingClientRect().width}px`
        const lineHeight = parseFloat(getComputedStyle(heightCalc).lineHeight)
        const divHeight = heightCalc.getBoundingClientRect().height
        this.rows =
          Math.floor(divHeight / lineHeight) === 0
            ? 1
            : Math.floor(divHeight / lineHeight + 1)
      }
    },
    checkValue(value: string) {
      value === '' ? (this.floatLabel = false) : (this.floatLabel = true)
      value.length > 11 ? (this.smallFont = true) : (this.smallFont = false)
    }
  },
  mounted() {
    this.checkValue(this.value)
  }
})
